import { render } from "./ScanOrderModal.vue?vue&type=template&id=c2194872&ts=true&lang=pug"
import script from "./ScanOrderModal.vue?vue&type=script&lang=ts"
export * from "./ScanOrderModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__